/* eslint-disable react/display-name */
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
interface RecaptchaProps {
  recaptchaRef: any;
  onChange(value: any): void;
}
export default (props: RecaptchaProps) => {
  const { recaptchaRef, onChange } = props;
  const key:
    | string
    | undefined = process.env.REACT_APP_GOOGLE_RECAPTCHA?.toString();

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      size={"invisible"}
      sitekey={"6LeDEBAaAAAAALpUmENFbnG_Kc-cN0H_Gch4BpRf"}
      onChange={onChange}
      // sitekey={!!key ? key : ''}
    />
  );
};
